var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBank(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.21584 1.2557L12.4658 3.35569C12.67 3.43736 12.8333 3.68235 12.8333 3.89818V5.83486C12.8333 6.15569 12.5708 6.41819 12.25 6.41819H1.75001C1.42917 6.41819 1.16667 6.15569 1.16667 5.83486V3.89818C1.16667 3.68235 1.33001 3.43736 1.53417 3.35569L6.78417 1.2557C6.90084 1.20904 7.09917 1.20904 7.21584 1.2557Z",
    stroke: "#235643",
    strokeWidth: 0.777778,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8333 12.8333H1.16667V11.0833C1.16667 10.7625 1.42917 10.5 1.75001 10.5H12.25C12.5708 10.5 12.8333 10.7625 12.8333 11.0833V12.8333Z",
    stroke: "#235643",
    strokeWidth: 0.777778,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.33333 10.4993V6.41602",
    stroke: "#235643",
    strokeWidth: 0.777778,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.66667 10.4993V6.41602",
    stroke: "#235643",
    strokeWidth: 0.777778,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7 10.4993V6.41602",
    stroke: "#235643",
    strokeWidth: 0.777778,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.33333 10.4993V6.41602",
    stroke: "#235643",
    strokeWidth: 0.777778,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6667 10.4993V6.41602",
    stroke: "#235643",
    strokeWidth: 0.777778,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M0.583328 12.834H13.4167",
    stroke: "#235643",
    strokeWidth: 0.777778,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M7 4.95898C7.48325 4.95898 7.875 4.56723 7.875 4.08398C7.875 3.60074 7.48325 3.20898 7 3.20898C6.51675 3.20898 6.125 3.60074 6.125 4.08398C6.125 4.56723 6.51675 4.95898 7 4.95898Z",
    stroke: "#235643",
    strokeWidth: 0.777778,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBank);
export default __webpack_public_path__ + "static/media/bank.dc7290c303bf487af5920de3684b66c9.svg";
export { ForwardRef as ReactComponent };